import { render, staticRenderFns } from "./CreateClientDlg.vue?vue&type=template&id=8f24bfe2&"
import script from "./CreateClientDlg.vue?vue&type=script&lang=js&"
export * from "./CreateClientDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports